<template>
	<div v-if="loaded">
		<section>
			<header class="page-title">
				<h2>Review Header</h2>
				<div class="ml-auto">
					<a class="btn btn-md btn-success" href="#" v-if="!userRoles.includes('users.translator')" @click.prevent="addNewRow(selectedSetting)"><i class="fas fa-plus"></i> Add Row</a>
					<a v-if="userRoles.includes('provider_types.settings_update')" @click="saveSettings" class="btn btn-md btn-success" href="#"><i class="fas fa-save"></i> Save Changes</a>
				</div>
			</header>
			<table>
				<tbody>
					<tr v-for="(row, index) in selectedSetting.properties.rows">
						<td class="td-with-padding">
							<div class="form-group">
								<label for="review-header-title">Feature Group Title</label>
								<div class="input-group">
									<input id="review-header-title" type="text" v-model="row['en'].title">
									<a href="#" class="btn btn-md btn-primary" @click.prevent="showModal(row)"><i class="fas fa-language icon-left"></i> Translate</a>
								</div>
							</div>
							<div class="form-group" v-if="!userRoles.includes('users.translator')">
								<label for="add-review-setting-property">Add Property</label>
								<div class="input-group">
									<select id="add-review-setting-property" v-model="row.selectedProperty">
										<option value="null">Select a property</option>
										<optgroup v-for="group in providerType.groups" :label="group.name">
											<option v-if="property.type === 'checkbox'" v-for="property in group.properties" :value="property">{{ property.name }}</option>
										</optgroup>
									</select>
									<a href="#" class="btn btn-md btn-primary" @click.prevent="addProperty(row)"><i class="fas fa-plus icon-left"></i> Add</a>
								</div>
							</div>
							<div class="form-group">
								<label>List of Properties</label>
								<table>
									<thead>
										<tr>
											<th></th>
											<th>Property Name</th>
											<th>Actions</th>
										</tr>
									</thead>
									<draggable :tag="'tbody'" @end="drag=false" @start="drag=true" v-model="row.properties">
										<tr v-for="(property, propertyIndex) in row.properties">
											<td class="text-center"><i class="fas fa-grip-lines"></i></td>
											<td>{{ property.name }}</td>
											<td class="actions" v-if="!userRoles.includes('users.translator')">
												<a href="#" class="btn btn-icon btn-danger" title="Delete" @click.prevent="row.properties.splice(propertyIndex, 1)"><i class="fas fa-fw fa-trash"></i></a>
											</td>
										</tr>
									</draggable>
								</table>
							</div>
						</td>
						<td class="actions text-center">
							<a href="#" class="btn btn-icon btn-danger" title="Delete" v-if="!userRoles.includes('users.translator')" @click.prevent="deleteRow(selectedSetting, index)"><i class="fas fa-fw fa-trash"></i></a>
						</td>
					</tr>
				</tbody>
			</table>
		</section>
		<hr v-if="!userRoles.includes('users.translator')" />
		<section v-if="!userRoles.includes('users.translator')">
			<header class="page-title">
				<h2>VPN Stats</h2>
			</header>
			<div class="flex box start">
				<div class="form-group six-lg">
					<label for="vpn-stats-1">First Value</label>
					<select id="vpn-stats-1" v-model="selectedSetting.properties.vpnStats[0]">
						<option value="null">Select a property</option>
						<optgroup v-for="group in providerType.groups" :label="group.name">
							<option v-for="property in group.properties" :value="property.id">{{ property.name }}</option>
						</optgroup>
					</select>
				</div>
				<div class="form-group six-lg">
					<label for="vpn-stats-2">Second Value</label>
					<select id="vpn-stats-2" v-model="selectedSetting.properties.vpnStats[1]">
						<option value="null">Select a property</option>
						<optgroup v-for="group in providerType.groups" :label="group.name">
							<option v-for="property in group.properties" :value="property.id">{{ property.name }}</option>
						</optgroup>
					</select>
				</div>
				<div class="form-group six-lg mb-0">
					<label for="vpn-stats-3">Third Value</label>
					<select id="vpn-stats-3" v-model="selectedSetting.properties.vpnStats[2]">
						<option value="null">Select a property</option>
						<optgroup v-for="group in providerType.groups" :label="group.name">
							<option v-for="property in group.properties" :value="property.id">{{ property.name }}</option>
						</optgroup>
					</select>
				</div>
				<div class="form-group six-lg">
					<label for="vpn-stats-4">Fourth Value</label>
					<select id="vpn-stats-4" v-model="selectedSetting.properties.vpnStats[3]">
						<option value="null">Select a property</option>
						<optgroup v-for="group in providerType.groups" :label="group.name">
							<option v-for="property in group.properties" :value="property.id">{{ property.name }}</option>
						</optgroup>
					</select>
				</div>
			</div>
		</section>

		<hr v-if="!userRoles.includes('users.translator')" />
		<section v-if="!userRoles.includes('users.translator')">
			<header class="page-title">
				<h2>Category list properties</h2>
			</header>
			<div class="flex box start">
				<div class="form-group six-lg">
					<label for="category-list-1">First Value</label>
					<select id="category-list-1" v-model="selectedSetting.properties.categoriesList[0]">
						<option value="null">Select a property</option>
						<optgroup v-for="group in providerType.groups" :label="group.name">
							<option v-for="property in group.properties" :value="property.id">{{ property.name }}</option>
						</optgroup>
					</select>
				</div>
				<div class="form-group six-lg">
					<label for="category-list-2">Second Value</label>
					<select id="category-list-2" v-model="selectedSetting.properties.categoriesList[1]">
						<option value="null">Select a property</option>
						<optgroup v-for="group in providerType.groups" :label="group.name">
							<option v-for="property in group.properties" :value="property.id">{{ property.name }}</option>
						</optgroup>
					</select>
				</div>
				<div class="form-group six-lg mb-0">
					<label for="category-list-3">Third Value</label>
					<select id="category-list-3" v-model="selectedSetting.properties.categoriesList[2]">
						<option value="null">Select a property</option>
						<optgroup v-for="group in providerType.groups" :label="group.name">
							<option v-for="property in group.properties" :value="property.id">{{ property.name }}</option>
						</optgroup>
					</select>
				</div>
			</div>
		</section>

		<div class="modal-bg" v-if="translationModal && selectedRow">
			<div class="modal">
				<header class="modal-header">
					<h4 class="modal-title">Edit Translations</h4>
					<a class="modal-close" title="Close modal" @click.prevent="hideModal"><i class="fas fa-times"></i></a>
				</header>
				<section class="modal-body">
					<div class="card mb-0">
						<header class="card-header language-list">
							<lang-selector></lang-selector>
						</header>
						<div class="card-body">
							<div class="form-group">
								<label for="trans">Translation</label>
								<input id="trans" type="text" v-model="selectedRow[clickedLang].title">
							</div>
						</div>
					</div>
				</section>
				<footer class="modal-footer">
					<a class="btn btn-md btn-success" href="#" @click.prevent="hideModal"><i class="fas fa-check"></i> Confirm</a>
				</footer>
			</div>
		</div>
	</div>
</template>

<script>
	import draggable from 'vuedraggable';
	import {eventBus} from '../../../app';
	import Errors from "../../../Utils/Errors";

	export default {
		components: {
			draggable
		},
		props: {
			dataProviderTypeId: {
				type: Number
			}
		},
		data() {
			return {
				providerTypeId: this.dataProviderTypeId,
				tabName: 'providerTypeReviewSettings',
				loaded: false,
				providerType: {},

				selectedSetting: {
					properties: {
						selectedProperty: null,
						rows: [],
						vpnStats: [null, null, null, null],
						categoriesList: [null,null,null]
					},
					is_review: true,
					is_default: false,
					name: 'Review Settings'
				},
				selectedRow: null,

				translationModal: false,
				clickedLang: this.$defaultLanguage.locale,

				userRoles: this.$currentUserRoles,
				errors: new Errors()
			}
		},
		mounted() {
			this.fetchDataFromApi();
			let vm = this;

			// When setActiveStatus method ran, change selected data in form fields
			/* From LangSelector */
			eventBus.$on('setActiveStatus', function (clickedLang) {
				vm.clickedLang = clickedLang;
			});
		},
		methods: {
			fetchDataFromApi: function () {
				let vm = this;
				eventBus.$emit('onLoaderStart');
				axios.post('/api/' + vm.$selectedSite.slug + '/providertype/fetchtabdata/' + vm.providerTypeId, {
					tab: vm.tabName
				})
					.then(response => {
						if (response.data.hasOwnProperty('data')) {
							if (response.data.data.hasOwnProperty('providerType')) {
								vm.providerType = response.data.data.providerType;
							}
							if (response.data.data.hasOwnProperty('allProviders')) {
								vm.allProviders = response.data.data.allProviders;
							}
							vm.getSettings();
							eventBus.$emit('onLoaderFinish');
							vm.loaded = true;
						}
					})
					.catch(e => {
						eventBus.$emit('onLoaderFinish');
						vm.$toastr.error('Api ' + vm.tabName + ' tab load failed', 'Error');
					});
			},
			showModal: function (row) {
				let vm = this;
				vm.translationModal = true;

				for (let i = 0; i < vm.$availableLanguages.length; i++) {
					if(!row.hasOwnProperty(vm.$availableLanguages[i].locale)) {
						row[vm.$availableLanguages[i].locale] = {
							title: ''
						};
					}
				}
				vm.selectedRow = row;
			},
			hideModal: function () {
				let vm = this;
				vm.translationModal = false;
				vm.selectedRow = null;
			},
			addNewRow: function (selectedSetting) {
				let vm = this;
				let obj = {
					properties: []
				};

				for (let i = 0; i < vm.$availableLanguages.length; i++) {
					obj[vm.$availableLanguages[i].locale] = {
						title: ''
					};
				}

				vm.selectedSetting.properties.rows.push(obj);
			},
			deleteRow: function (selectedSetting, index) {
				let vm = this;
				vm.selectedSetting.properties.rows.splice(index, 1);
			},
			addProperty: function (reviewSetting) {
				let vm = this;
				reviewSetting.properties.push(reviewSetting.selectedProperty);
			},
			getSettings: function () {
				let vm = this;
				eventBus.$emit('onLoaderStart');

				axios.get('/api/' + vm.$selectedSite.slug + '/provider-types/' + vm.providerType.id + '/getReviewSettings')
					.then(response => {
						if (response.data.hasOwnProperty('properties')) {
							vm.selectedSetting = response.data;
							if (!vm.selectedSetting.properties.hasOwnProperty('categoriesList')) {
								vm.selectedSetting.properties.categoriesList = [null,null,null];
							} // if
						}
						eventBus.$emit('onLoaderFinish');
						this.$toastr.success('Provider Type settings loaded successfully.');
					})
					.catch(e => {
						this.errors.record(e.response.data);
						eventBus.$emit('onLoaderFinish');
						this.$toastr.error('Provider Type settings save failed.', 'Error');
					});
			},
			saveSettings: function () {
				let vm = this;
				eventBus.$emit('onLoaderStart');

				axios.post('/api/' + vm.$selectedSite.slug + '/provider-types/' + vm.providerType.id + '/saveReviewSettings', vm.selectedSetting)
					.then(response => {
						vm.selectedSetting = response.data;
						eventBus.$emit('onLoaderFinish');
						this.$toastr.success('Provider Type settings updated successfully.');
					})
					.catch(e => {
						this.errors.record(e.response.data);
						eventBus.$emit('onLoaderFinish');
						this.$toastr.error('Provider Type settings save failed.', 'Error');
					});
			}
		}
	}
</script>

<style scoped>

</style>
